import React, { Component } from 'react';
import { connect } from 'react-redux';
import $ from 'jquery';
import {setTradeAddress} from '../../../../actions/ui/marketplace';
import ReactTooltip from 'react-tooltip'

class TradeAddresses extends Component {
  constructor(){
    super();
    this.state = {trade1:null,trade2:null,lastTime:Date.now()};
  }
  render() {
    return (
      <div style={{}}>
        {this.renderAddresses()}
      </div>
    );
  }
  setAddress(chain,addr){
    let _this = this;
    this.props.setTradeAddress(chain,addr,()=>{
      if(this.props.market.asset.toLowerCase() == chain){
        _this.setState({trade1:addr,lastTime:Date.now()})
      }
      else {
        _this.setState({trade2:addr,lastTime:Date.now()})
      }
    })
    return
  }
  renderAddresses(){
    const shortenHash = function (hash: string, partLength: number = 5) {
      if(!hash) return '';
      else return hash.slice(0, partLength) + '...' + hash.slice(hash.length - partLength, hash.length)
    }
    let curr1 = this.props.market.asset
    let curr2 = this.props.market.denomination
    let trade1 = Date.now() < this.state.lastTime && this.state.trade1 ? this.state.trade1 : this.props.tradeAddresses[curr1.toLowerCase()]
    let trade2 = Date.now() < this.state.lastTime && this.state.trade2 ? this.state.trade2 : this.props.tradeAddresses[curr2.toLowerCase()]


    let addresses1 = this.props.wallet[curr1.toLowerCase()] ? Object.keys(this.props.wallet[curr1.toLowerCase()]).map((a,i) => {
      let opacity = trade1 == a ? 1: 0.5;
      return (
        <p key={i} onClick={this.setAddress.bind(this,curr1.toLowerCase(),a)} style={{padding:'2px',opacity,fontSize:'10px', lineHeight:'25px', cursor:'pointer'}}>
          {a}
        </p>
      )
    }) : '';

    let addresses2 = this.props.wallet[curr2.toLowerCase()] ? Object.keys(this.props.wallet[curr2.toLowerCase()]).map((a,i) => {
      let opacity = trade2 == a ? 1: 0.5;
      return (
        <p key={i} onClick={this.setAddress.bind(this,curr2.toLowerCase(),a)} style={{padding:'2px',opacity,fontSize:'10px', lineHeight:'25px', cursor:'pointer'}}>
          {a}
        </p>
      )
    }) : '';

    return (
      <>
      <div className='col s6'>
        <div style={{marginBottom:'10px'}}>
          <p style={{color:'white',fontSize:'10px',cursor:'pointer'}}
            ref={(c) => { this.ref = c; }}
            data-tip={`hello1`} data-for={'address_tooltip1'}
            >
            <span style={{opacity:0.8}}>{curr1.toUpperCase()}:</span> {shortenHash(trade1)}
          </p>
        </div>
      </div>
      <div className='col s6'>
        <div style={{marginBottom:'10px'}}>
          <p style={{color:'white',fontSize:'10px',cursor:'pointer'}}
            ref={(c) => { this.ref = c; }}
            data-tip={`hello2`} data-for={'address_tooltip2'}
            onMouseOver={() => { ReactTooltip.show(this.ref); }}
            onMouseLeave={() => { ReactTooltip.hide(this.ref); }}
            >
            <span style={{opacity:0.8}}>{curr2.toUpperCase().replace('NRG','OL')}:</span> {shortenHash(trade2)}
          </p>
        </div>
      </div>
      <ReactTooltip id={'address_tooltip1'} place="top" type="dark" effect="solid" className='extraClass' delayHide={100}>
        <p>Choose {curr1.toUpperCase().replace('NRG','OL')} Address: </p>
        <hr/>
        {addresses1}
      </ReactTooltip>

      <ReactTooltip id={'address_tooltip2'} place="top" type="dark" effect="solid" className='extraClass' delayHide={100}>
        <p>Choose {curr2.toUpperCase().replace('NRG','OL')} Address: </p>
        <hr/>
        {addresses2}
      </ReactTooltip>
      </>
    )
  }
}

function mapStateToProps(state) {
  return {
    tradeAddresses: state.passport.tradeAddresses,
    market: state.ui_marketplace.market,
    wallet: state.passport.wallet,
  }
}

export default connect(mapStateToProps,{setTradeAddress})(TradeAddresses);
